import { Checkbox } from '@global-engineering-shared/gweb-material-ui';

import useStyles from 'components/Table/TableCheckBoxAll/TableCheckBoxAll.styles';
import { usePaginatedItemsContext } from 'context/PaginatedItems/context/PaginatedItemsProvider';
import { PaginatedItems } from 'context/PaginatedItems/types/PaginatedItems';
import { useSelectedEntitiesContext } from 'context/SelectedEntities/SelectedEntitiesProvider';
import { TTableEntity } from 'types/tableEntityType';
import { areAllEntitiesSelected } from 'utils/areAllEntitiesSelected';

const TableCheckBoxAll = () => {
  const classes = useStyles();

  const { selectedEntities, areEntitiesSelected, toggleSelectAllEntities } =
    useSelectedEntitiesContext();
  const { items } = usePaginatedItemsContext() as PaginatedItems<TTableEntity>;

  if (items.length === 0) {
    return null;
  }

  const allSelected = areAllEntitiesSelected(selectedEntities, items);
  const isIndeterminate = areEntitiesSelected && !allSelected;

  return (
    <Checkbox
      checked={allSelected}
      indeterminate={isIndeterminate}
      onClick={(event) => {
        event.stopPropagation();
      }}
      onChange={() => toggleSelectAllEntities(items)}
      className={classes.checkbox}
    />
  );
};

export default TableCheckBoxAll;
